import React from "react";

const Privacy = () => {
  return (
    // Gray background covers the entire screen including top padding
    <div className="bg-gray-100 min-h-screen pt-24 px-4 sm:px-6 lg:px-8 flex justify-center">
      {/* White card with rounded edges, responsive width, and bottom margin */}
      <div className="w-full max-w-3xl bg-white shadow-md rounded-2xl p-6 sm:p-10 mb-12">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-center text-gray-800">
          Privacy Policy
        </h1>
        <p className="mb-4 text-gray-500 text-sm sm:text-base text-center">
          Last update: September 23, 2025
        </p>

        <p className="mb-4 text-gray-700 text-base sm:text-lg leading-relaxed">
          At Carmie, we value your privacy and are committed to protecting your
          personal information. This Privacy Policy outlines how we collect,
          use, and safeguard your data when you use our services.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Information We Collect
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          We may collect personal details such as your name, contact
          information, and location when you use our app. We also collect
          non-personal data like device information, app usage statistics, and
          cookies for analytics.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          How We Use Your Information
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Your data is used to provide and improve our services, facilitate
          communication between clients and mechanics, process payments, and
          ensure safety and security on our platform.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Data Protection
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          We take the security of your data seriously and implement appropriate
          technical and organizational measures to protect it against
          unauthorized or unlawful processing and against accidental loss,
          destruction, or damage.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Sharing of Information
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          We do not sell or trade your information to third parties. Data may
          only be shared with trusted partners for service delivery, legal
          compliance, or with your explicit consent.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Your Rights
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          You have the right to access, update, or request deletion of your data
          at any time. Please contact us if you wish to exercise these rights.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Updates to this Policy
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          We may update this Privacy Policy from time to time. Any changes will
          be reflected here with the updated date.
        </p>

        <p className="mt-8 text-gray-600 text-sm text-center">
          If you have any questions about this Privacy Policy, please contact us
          at{" "}
          <a
            href="mailto:customercare@carmie.biz"
            className="text-green-600 hover:underline"
          >
            customercare@carmie.biz
          </a>
        </p>
      </div>
    </div>
  );
};

export default Privacy;

// // privacy.jsx
// import React from "react";

// const PrivacyPolicy = () => {
//   return (
//     <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800 leading-relaxed">
//       <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
//       <p className="mb-4">Effective Date: September 23, 2025</p>
//       <p className="mb-4">
//         At <strong>Carmie</strong>, we respect your privacy and are committed to
//         protecting your personal information. This Privacy Policy explains how
//         we collect, use, and safeguard your data when you use our app and
//         services.
//       </p>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">
//         1. Information We Collect
//       </h2>
//       <p className="mb-4">We may collect the following types of information:</p>
//       <ul className="list-disc pl-6 mb-4">
//         <li>Personal details such as name, phone number, and email.</li>
//         <li>Vehicle information and service history.</li>
//         <li>Location data to connect you with nearby mechanics.</li>
//         <li>Payment details when you make transactions through the app.</li>
//       </ul>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">
//         2. How We Use Your Information
//       </h2>
//       <ul className="list-disc pl-6 mb-4">
//         <li>To provide and improve our services.</li>
//         <li>To match clients with mechanics and garages.</li>
//         <li>To process payments securely.</li>
//         <li>To send updates, confirmations, and important notifications.</li>
//       </ul>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">
//         3. Sharing of Information
//       </h2>
//       <p className="mb-4">
//         We do not sell your personal data. We may share limited information
//         with:
//       </p>
//       <ul className="list-disc pl-6 mb-4">
//         <li>Mechanics and garages to fulfill your service request.</li>
//         <li>Payment providers to process your transactions.</li>
//         <li>Regulators or legal authorities if required by law.</li>
//       </ul>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">4. Data Security</h2>
//       <p className="mb-4">
//         We implement reasonable security measures to protect your information.
//         However, no system is 100% secure, and we encourage you to also take
//         precautions when using our app.
//       </p>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">5. Your Rights</h2>
//       <p className="mb-4">
//         You have the right to access, correct, or delete your personal data.
//         Please contact us if you would like to exercise these rights.
//       </p>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">
//         6. Changes to This Policy
//       </h2>
//       <p className="mb-4">
//         We may update this Privacy Policy from time to time. Any changes will be
//         posted on this page with a new effective date.
//       </p>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">7. Contact Us</h2>
//       <p>
//         If you have any questions about this Privacy Policy, please contact us
//         at:{" "}
//         <a href="mailto:privacy@carmie.biz" className="text-blue-600 underline">
//           privacy@carmie.biz
//         </a>
//       </p>
//     </div>
//   );
// };

// export default PrivacyPolicy;
